import React from 'react';

import FancyButton from './fancyButton'; // Adjust path if needed
import './ctaSection.css';

function CTASection({ title, description, buttonText, buttonLink }) {
  return (
    <section className="cta-section">
      <div className="cta-content">
        <h2>{title}</h2>
        <p>{description}</p>
        <a
          href={buttonLink}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <FancyButton variant="primary">{buttonText}</FancyButton>
        </a>
      </div>
    </section>
  );
}

export default CTASection;
